<div class="content-container margin-bottom">
    <section role="region" aria-label="Projects controls" class="controls">
        <h2 class="visually-hidden">Projects controls</h2>
        <div class="left-controls">
            <div class="filters">
                <app-filter-editor [formControl]="filterControl"
                    [chips]="['title', 'dept', 'mfk', 'oaccount', 'effort', 'key', 'member.hawkid']"
                    [flags]="['archived']" [selectedFilters]="(selectedFilters | async) || []"
                    label="Filter projects - search by attribute or type freely to search all."
                    (filterChange)="filterChange($event)" #filter
                    [chipPossVals]="chipPossVals" [chipHelpers]='chipHelpers' class="filter-editor">
                </app-filter-editor>

                <button mat-stroked-button (click)="selectedFilters.next([])">
                    <mat-icon class="material-symbols-outlined">clear</mat-icon>
                    Clear
                </button>
            </div>
        </div>

        <div class="right-controls">
            @if (canAdd) {
            <button mat-stroked-button (click)="openCreateDialog()">
                <mat-icon>add</mat-icon>
                Add New Project
            </button>
            }
        </div>
    </section>
</div>

<div class="content-container working-with margin-sm-bottom">
    @if (effort) {
    <div class="working-with-item">
    <div class="mode-helper arrow-box">
    <button mat-icon-button (click)='clearFilter("effort")'
        title="Remove effort filter from filters.">
        <mat-icon>cancel</mat-icon>
    </button>
    <span>Working with effort: <b>'{{effort.title}}'</b></span>
    </div>
    @if (canAddToEffort(effort)) {
    <button mat-stroked-button class="specific-action" (click)="openCreateDialog(effort)">
        <mat-icon>add</mat-icon>
        Add Project to Effort
    </button>
    }
    </div>
    }

    @if (user) {
    <div class="working-with-item">
    <div class="mode-helper arrow-box">
    <button mat-icon-button (click)='clearFilter("member.hawkid")'
        title="Remove member.hawkid from filters." aria-label="Remove user filter">
        <mat-icon>cancel</mat-icon>
    </button>
    <span>Working with user: <b>'{{user.displayName ?? user.hawkId}}'</b></span>
    </div>
    <button mat-stroked-button class="specific-action" (click)="openBatchEditDialog(user)"
        [attr.aria-label]="'Bulk edit projects for ' + (user.displayName ?? user.hawkId)">
        <mat-icon class="material-symbols-outlined">person_play</mat-icon>
        Bulk edit projects
    </button>
    </div>
    }
</div>


<section role="region" aria-label="Projects table entries" class='projects-table-container'>
    <h2 class="visually-hidden">Projects table entries</h2>
    <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="title" scope="col">

        <!-- Project Title Column -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Project Title </th>
            <td mat-cell *matCellDef="let project">
                @if (canModify(project)) {
                <a href="javascript:void(0)" (click)="openEditDialog(project)" title="Edit this project."
                    [class.is-archived]="project.isDeleted">{{ project.title }}</a>
                } @else {
                <span [class.is-archived]="project.isDeleted">{{ project.title }}</span>
                }
            </td>
        </ng-container>

        <!-- Effort Title Column -->
        <ng-container matColumnDef="effortTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Effort Title </th>
            <td mat-cell *matCellDef="let project">
                <a [routerLink]="['/projects']" [queryParams]="{ 'filter.effort': project.effort?.key }"
                    title="Filter for effort type '{{ project.effort?.title }}.'" [class.is-archived]="project.effort?.isDeleted">{{ project.effort?.title }}</a>
                &nbsp;
                <a [routerLink]="['/efforts']" [queryParams]="{ 'filter.key': project.effort?.key, 'filter.archived': project.effort?.isDeleted ? 1 : undefined }"
                    title="View effort in Efforts tab.">(go to effort)</a>
            </td>
        </ng-container>

        <!-- Owner Column -->
        <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Owner </th>
            <td mat-cell *matCellDef="let project">
                <a [routerLink]="['/projects']" [queryParams]="{ 'filter.owner': project.owner }"
                    title="Filter by owner '{{ project.owner }}.'">{{ project.owner }}</a>
            </td>
        </ng-container>

        <!-- Customer Column -->
        <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Customer </th>
            <td mat-cell *matCellDef="let project">
                <a [routerLink]="['/projects']" [queryParams]="{ 'filter.cust': project.customer }"
                    title="Filter by customer '{{ project.customer }}.'">{{ project.customer }}</a>
            </td>
        </ng-container>

        <!-- OAccount Column -->
        <ng-container matColumnDef="oAccount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> OAccount </th>
            <td mat-cell *matCellDef="let project"> {{ project.oAccount }} </td>
        </ng-container>

        <!-- MFK Column -->
        <ng-container matColumnDef="mfk">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> MFK </th>
            <td mat-cell *matCellDef="let project"> {{ project.mfk }} </td>
        </ng-container>

        <!-- Members Column -->
        <ng-container matColumnDef="members">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Members </th>
            <td mat-cell *matCellDef="let project">
                <a [routerLink]="['/users']" [queryParams]="{ 'filter.project.key': project.key }"
                    title="View and edit memberships for '{{ project.title }}.'">
                    {{ project.projectMembers?.length }} members
                </a>
            </td>
        </ng-container>

        <!-- Project Key Column -->
        <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Key </th>
            <td mat-cell *matCellDef="let project">
                @if (canModify(project)) {
                <a href="javascript:void(0)" (click)="openEditDialog(project)" title="Edit this project.">{{ project.key }}</a>
                } @else {
                {{ project.key }}
                }
            </td>
        </ng-container>

                <ng-container matColumnDef="tools">
            <th mat-header-cell *matHeaderCellDef scope="col" class="user-specific-tools">Actions</th>
            <td mat-cell *matCellDef="let project" class="user-specific-tools">
                @if (canModify(project) && user) {
                <button mat-icon-button aria-label="Remove user membership" (click)="deleteMembership(project, user)" [title]="'Remove user membership for ' + (user.displayName ?? user.hawkId) + ' from project ' + project.title">
                    <mat-icon>group_remove</mat-icon>
                </button>
                }
            </td>
        </ng-container>


        <!-- header no results message -->
        <ng-container matColumnDef='no-results'>
            <td mat-header-cell *matHeaderCellDef [attr.colspan]='displayedColumns.length'
                class='whole-row-no-results whole-row-helper'>
                @if (! (isLoading | async)) {
                <div>
                    <p>No projects found.
                        @if (filters?.length) {
                        <button mat-flat-button color="accent" (click)='selectedFilters.next([])'>Clear Filter</button>
                        }
                        @if (canAdd) {
                        <button mat-stroked-button color="primary" (click)="openCreateDialog()"><mat-icon>add</mat-icon>
                            Add New Project
                        </button>
                        }
                    </p>
                </div>
                }
            </td>
        </ng-container>

        <!-- Affiliates Column -->
        <!-- <ng-container matColumnDef="affiliates">
  <th mat-header-cell *matHeaderCellDef> Affiliates </th>
  <td mat-cell *matCellDef="let project">
    {{ project.affiliates.slice(0, 3).join(', ') }}
    <ng-container *ngIf="project.affiliates.length > 3">
      and {{ project.affiliates.length - 3 }} others
    </ng-container>
  </td>
</ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
        </tr>
        <tr mat-row *matRowDef="let row; 
            columns: displayedColumns">
        </tr>
        <tr [hidden]='dataSource.data.length > 0' mat-header-row *matHeaderRowDef="['no-results'];" class="no-results">
        </tr>
    </table>

    <div class="loading-data" [class.showing]="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>
</section>

<section role="region" aria-label="Projects table pagination" class="bottom-tools">
    <h2 class="visually-hidden">Projects table pagination</h2>
    <mat-paginator [pageSizeOptions]="[10, 15, 20, 30, 50, 100]" showFirstLastButtons [pageSize]="pageSize"
        [length]="totalProjects">
    </mat-paginator>
</section>
